import React from "react";
import { Row, Col} from "shards-react";

const Table14 = (props) => {
  return (
    <Row>
      <Col md="12" style={{ padding: "15px" }}>
        <h3>กรุณาเพิ่ม ข้อมูลต่างๆ ในตัวชี้วัดที่ 44 : ต้นทุนค่าขนส่งต่อผลิตภัณฑ์มวลรวมภายในประเทศ/สัดส่วนต้นทุนโลจิสติกส์ ต่อ GDP ของประเทศไทย</h3>
      </Col>
    </Row>
  );
};

export default Table14;
